import { render } from "./UploadPhoneView.vue?vue&type=template&id=4c726beb&scoped=true"
import script from "./UploadPhoneView.vue?vue&type=script&lang=js"
export * from "./UploadPhoneView.vue?vue&type=script&lang=js"

import "./UploadPhoneView.vue?vue&type=style&index=0&id=4c726beb&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c726beb"]])

export default __exports__